/**
 *  Cookiebot related helper functions
 */
//import Cookies from 'js-cookie';

export default class CookiebotHelper {

  /**
   * Constructor
   */
  constructor() {
    this.selectors = {
      dialog: '#CybotCookiebotDialog'
    }
  }


  addConsentListeners() {
    window.addEventListener('CookiebotOnConsentReady', (e) => {
      if (!window.Cookiebot.consent.statistics) {
        this._removeStatisticCookies();
      }
    }, false);

  }

  /**
   * Enables cookiebot widget to be opened from custom links/buttons
   * @param {string} selector Selector for custom links/buttons
   */
  initCustomWidgetOpeners(selector) {
    const links =  document.querySelectorAll(selector);
    links.forEach((link) => {
      link.addEventListener('click', () => {
        if(window.Cookiebot) {
          window.Cookiebot.renew();
          this._moveFocusToDialog(1000);
        }
      });
    })
  }

  /**
   * After delay, move focus to dialog
   * It will take a second for dialog to appear, and then we want to move the focus to it
   * @param {number} delay time in milliseconds
   */
  _moveFocusToDialog(delay) {
    setTimeout(() => {
      const cookieDialog = document.querySelector(this.selectors.dialog);
      if(cookieDialog) {
        cookieDialog.focus();
      }
    }, delay);
  }

  _removeStatisticCookies() {
    //Cookies.remove('ecommerceItem'); No need to remove this, cookie counted as necessary
  }

}
